import React from 'react';
import '../assets/styles/SuggestedResponses.css';

const SuggestedResponses = ({ suggestions, onSuggestionClick, visible = true }) => {
  if (!visible || !suggestions || suggestions.length === 0) {
    return null;
  }

  return (
    <div className="suggested-responses-container">
      {suggestions.map((suggestion, index) => (
        <button
          key={index}
          className="suggestion-bubble"
          onClick={() => onSuggestionClick(suggestion)}
        >
          {suggestion}
        </button>
      ))}
    </div>
  );
};

export default SuggestedResponses;
